import AuthService from './AuthService.ts';
import BannerService from './BannerService.ts';

export const authService = new AuthService();
export const bannerService = new BannerService();
